module.exports = "https://cdn.redage.net/src/views/fractions/war/map/map.jpg";